require('../../modules/es.object.entries');
var path = require('../../internals/path');

module.exports = path.Object.entries;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/object/entries.js
// module id = 998
// module chunks = 0